export const PAYMENT = {
  CASH: "COD",
  CREDIT_CARD: "CCOD",
  PREPAID: "CARD",
};
export const PAYMENT_STATUS = {
  PREPAID: "PREPAID",
  UNPAID: "UNPAID",
};
export const PAYFORT_STATUS = {
  SUCCESS: "18",
};

export const PAYFORT_3DS_STATUS = {
  SUCCESS: "14000",
  TRANSACTION_DECLINED: "666",
  INSUFFICIENT_FUNDS: "029",
  INVALID_CARD_NUMBER: "016",
  CARD_EXPIRED: "012"
};

export const VALIDATION_TYPES = {
  MENU: "MENU",
  CATEGORY: "CATEGORY",
  ITEM: "ITEM",
  MODIFIER_GROUP: "MODIFIER_GROUP",
  MODIFIER: "MODIFIER"
};

export const VALIDATION_TYPE_NAMES = {
  MENU: "Menu",
  CATEGORY: "Category",
  ITEM: "Menu Item",
  MODIFIER_GROUP: "Modifier Group",
  MODIFIER: "Modifier"
};

export const VALIDATION_TYPE_DISPLAY = {
  [VALIDATION_TYPES.MENU]: VALIDATION_TYPE_NAMES.MENU,
  [VALIDATION_TYPES.CATEGORY]: VALIDATION_TYPE_NAMES.CATEGORY,
  [VALIDATION_TYPES.ITEM]: VALIDATION_TYPE_NAMES.ITEM,
  [VALIDATION_TYPES.MODIFIER_GROUP]: VALIDATION_TYPE_NAMES.MODIFIER_GROUP,
  [VALIDATION_TYPES.MODIFIER]: VALIDATION_TYPE_NAMES.MODIFIER
};

export const VALIDATION_STATUS = {
  NOT_APPLICABLE: "NOT_APPLICABLE",
  VALID: "VALID",
  MISSING: "MISSING",
  INVALID: "INVALID"
};

export const VALIDATION_FIELD_TYPES = {
  IMAGE: "image",
  PRICE: "price",
  DESCRIPTION: "description",
  DESCRIPTION_TRANSLATION: "descriptionTranslation",
  NAME_TRANSLATION: "nameTranslation",
  CHANNEL_NAME_TRANSLATION: "channelNameTranslation",
  CHANNEL_DESCRIPTION_TRANSLATION: "channelDescriptionTranslation",
  DUPLICATE_ITEM_NAME_PRICE: "duplicateItemNamePrice",
  NUTRITION_INFO: "nutritionInfo"
};

export const VALIDATION_FIELD_NAMES = {
  [VALIDATION_FIELD_TYPES.IMAGE]: "Image",
  [VALIDATION_FIELD_TYPES.PRICE]: "Price",
  [VALIDATION_FIELD_TYPES.DESCRIPTION]: "Description",
  [VALIDATION_FIELD_TYPES.DESCRIPTION_TRANSLATION]: "Description Translation",
  [VALIDATION_FIELD_TYPES.NAME_TRANSLATION]: "Name Translation",
  [VALIDATION_FIELD_TYPES.CHANNEL_NAME_TRANSLATION]: "Channel Name Translation",
  [VALIDATION_FIELD_TYPES.CHANNEL_DESCRIPTION_TRANSLATION]: "Channel Description Translation",
  [VALIDATION_FIELD_TYPES.DUPLICATE_ITEM_NAME_PRICE]: "Duplicate Item Different Prices",
  [VALIDATION_FIELD_TYPES.NUTRITION_INFO]: "Calorie Info"
};

/**
 * Activations menu validation: display labels for every validation type the
 * activations-bff strategies can emit in `metadata.applicableValidations`.
 *
 * Combines the existing web-order types with the new ITRTL-720 dimensions
 * (architecture-plan §5.3). Unknown keys fall back to a humanised label via
 * `getValidationLabel`.
 */
export const ACTIVATIONS_VALIDATION_LABELS = {
  // existing (web-order shared)
  image: "Image",
  price: "Price",
  description: "Description",
  nameTranslation: "Name Translation",
  descriptionTranslation: "Description Translation",
  channelNameTranslation: "Channel Name Translation",
  channelDescriptionTranslation: "Channel Description Translation",
  nutritionInfo: "Calorie Info",
  duplicateItemNamePrice: "Duplicate Item Different Prices",
  // new (ITRTL-720)
  arabicTranslation: "Arabic Translation",
  specialCharacters: "Special Characters",
  multipleSelectionModifier: "Multiple Selection Modifier",
  nestedModifier: "Nested Modifier",
  allergens: "Allergens",
  charLimit: "Character Limit",
  restrictedWords: "Restricted Words",
  maxProducts: "Max Products",
  maxModifiers: "Max Modifiers",
  modifierCalories: "Modifier Calories",
  imageResolution: "Image Resolution"
};

/**
 * Stable column/filter order for activations validation types. Any type present
 * in `applicableValidations` but absent here is appended after, in response order.
 */
export const ACTIVATIONS_VALIDATION_ORDER = [
  "image",
  "imageResolution",
  "price",
  "description",
  "charLimit",
  "specialCharacters",
  "restrictedWords",
  "arabicTranslation",
  "nameTranslation",
  "descriptionTranslation",
  "channelNameTranslation",
  "channelDescriptionTranslation",
  "nutritionInfo",
  "modifierCalories",
  "allergens",
  "multipleSelectionModifier",
  "nestedModifier",
  "maxProducts",
  "maxModifiers",
  "duplicateItemNamePrice"
];

// Helpers that derive display values from the constants above live in ./validationFields.js,
// keeping this file a pure constants/enums module.